module.exports = __webpack_public_path__ + "static/media/FOTO 3.9.12ac14ae.jpg";